module.exports = __webpack_public_path__ + "static/media/1_en.6dd928e5.png";